<!-- <div class="label-bar"> -->
<!-- <app-common-button
      title="Refresh"
      icon="fas fa-sync-alt"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onRefresh()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
    <app-common-button
      icon="fas fa-download"
      title="Download "
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onDownload()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>

    <app-common-button
      label="Create"
      title="Create Decision"
      icon="fas fa-plus-circle"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      [critical]="true"
      (clicked)="onCreate()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button> -->
<!-- <span class="example-spacer"></span>
  <app-common-button
    label="Save & Next"
    title="Save & Next"
    [buttonId]="1111"
    [critical]="false"
    width="110px"
    (clicked)="onSave()"
    style="margin-left: 6px; margin-right: 6px"
  >
  </app-common-button> -->
<!-- </div> -->

<div class="card" style="width: 100%">
  <form [formGroup]="form">
    <!-- Dynamic grid with rows - use cached properties -->
    <div class="dynamic-grid" [style.gridTemplateColumns]="gridTemplateColumns">
      <ng-container *ngFor="let row of gridRows">
         <!-- Place each field in its grid position -->
      <ng-container *ngFor="let field of row.fields">
        <div class="grid-item" 
               [style.gridColumn]="getGridColumnSpan(field)"
               [style.gridRow]="getGridRowSpan(field)">

        <ng-container [ngSwitch]="field.type">
          <!-- TEXT -->
          <mat-form-field
            *ngSwitchCase="'text'"
            appearance="outline"
            class="field"
          >
            <mat-label>{{ field.label }}</mat-label>
            <input matInput [formControlName]="field.key" />
          </mat-form-field>


          <!-- SELECT -->
          <mat-form-field
            *ngSwitchCase="'select'"
            appearance="outline"
            class="field"
          >
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.key">
              <mat-option
                *ngFor="let opt of field.options"
                [value]="opt.value"
              >
                {{ opt.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- DATE (Angular Material Datepicker) -->
          <mat-form-field
            *ngSwitchCase="'date'"
            appearance="outline"
            class="field"
          >
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [formControlName]="field.key"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <!--Radio  -->
          <div *ngSwitchCase="'radio'" class="field">
            <label class="radio-label" style="margin-right: 3%;">{{ field.label }}</label>
            <mat-radio-group [formControlName]="field.key">
              <mat-radio-button class="mr-4"
                *ngFor="let opt of field.options"
                [value]="opt.value"
              >
                {{ opt.label }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngSwitchCase="'checkbox'" class="field checkbox-field">
            <mat-checkbox [formControlName]="field.key">
              {{ field.label }}
            </mat-checkbox>
          </div>

          <!-- CUSTOM -->
          <mat-form-field
            *ngSwitchCase="'custom'"
            appearance="outline"
            class="field"
          >
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              [formControlName]="field.key"
              readonly
              (click)="openCustomDialog(field)"
            />
            <mat-icon
              matSuffix
              style="cursor: pointer"
              (click)="openCustomDialog(field)"
            >
              search
            </mat-icon> 
            <mat-hint *ngIf="selectedMedicalConcept">

              <span class="item-name">{{selectedMedicalConcept.level}} : </span>
                <span class="item-code" *ngIf="selectedMedicalConcept.code">({{ selectedMedicalConcept.code }})</span>
                <span class="item-level" style="color: black; margin-left: 5px;">{{ selectedMedicalConcept.name || selectedMedicalConcept.term }}</span>
                
            </mat-hint>
            <br>
             <mat-hint *ngIf="selectedMedicalConcept" style="margin-left: 2%;">
              <span class="item-name" style="color: black;">MedDRA Version: {{medDRAVersion}}</span>
             </mat-hint>
          </mat-form-field>

                    <!-- TEXTAREA -->
          <mat-form-field
            *ngSwitchCase="'textarea'"
            appearance="outline"
            class="field textarea"
          >
            <mat-label>{{ field.label }}</mat-label>
            <textarea
              matInput
              rows="1"
              [formControlName]="field.key"
            ></textarea>
            <mat-error >
              <span *ngIf="form.get(field.key).hasError('maxlength')">
                 {{field.label}} is exceed maximum length 5000.
              </span>
            </mat-error>
          </mat-form-field>
          </ng-container>
          </div>
          
        </ng-container>
      </ng-container>
    </div>

    <!-- TME SECTION -->
<div  [hidden]="!form.get('isTme')?.value" class="tme-section" formGroupName="tme">

  <h3 class="tme-title" style="font-size: 15px;">TME Section</h3>

  <div class="tme-grid">
    <mat-form-field appearance="outline">
      <mat-label>Type of TME</mat-label>
      <mat-select formControlName="tmeType">
        <mat-option value="AESI">AESI</mat-option>
        <mat-option value="Event to Monitor">Event to Monitor</mat-option>
        <mat-option value="TME Only">TME Only</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>TME Start Date</mat-label>
      <input matInput [matDatepicker]="start" formControlName="tmeStartDate">
      <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
      <mat-datepicker #start></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>TME End Date</mat-label>
      <input matInput [matDatepicker]="end" formControlName="tmeEndDate">
      <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
      <mat-datepicker #end></mat-datepicker>
    </mat-form-field>
  </div>

  <div formGroupName="monitoring" class="monitoring-section">

    <h3 style="font-size: 15px; border-bottom: 1px solid #ccc;">TME Monitoring</h3>

    <mat-checkbox formControlName="guidedQuestion">
      Guided Question (GQ)
    </mat-checkbox>

    <mat-checkbox formControlName="dedicatedEcrf">
      Dedicated eCRF (electronic Case Report Form)
    </mat-checkbox>

    <mat-checkbox formControlName="aesiOngoingStudy">
      AESI applicable to ongoing Study
    </mat-checkbox>

    <mat-checkbox formControlName="reviewActivityPss">
      Review Activity in the PSS
    </mat-checkbox>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Any additional Info or Comments</mat-label>
      <textarea matInput formControlName="additionalInfo"></textarea>
    </mat-form-field>

  </div>
</div>

  </form>
</div>
